export default __webpack_public_path__ + "static/media/thanks.62e135fa.jpg";